import React, { useEffect } from 'react';
import { InformationOutline } from 'pcln-icons';
import { GenericBanner, Flex, Text } from 'pcln-design-system';
import analytics from '../../analytics/analytics';
import { useChatUIContext } from '../../hooks/useChatUIContext';
import { useLoadingStateContext } from '../../hooks/useLoadingStateContext';
/**
 * ErrorComponent
 * @public
 */
const TryAgain = ({
  lastMessage
}) => {
  useEffect(() => {
    analytics.log({
      message: `TryAgain-component: ${lastMessage}`,
      source: 'TryAgain'
    });
  }, [lastMessage]);
  const {
    setOpenErrorComponent
  } = useChatUIContext();
  const {
    setLoadingStatus
  } = useLoadingStateContext();
  useEffect(() => {
    setLoadingStatus(false);
  }, []);
  const tryAgainHandler = function () {
    setOpenErrorComponent(false);
  };
  return React.createElement(Flex, {
    flexDirection: 'column',
    justifyContent: 'center',
    "data-testid": 'try-again'
  }, React.createElement(GenericBanner, {
    mx: 3,
    my: 3,
    p: 2,
    borderRadius: 'lg',
    color: 'background.light',
    iconLeft: React.createElement(InformationOutline, {
      color: 'warning.base',
      "data-testid": 'information-outline-icon'
    }),
    text: React.createElement(Text.span, {
      textStyle: 'subheading6'
    }, "I'm having some trouble coming up with a response right now.\u00A0", React.createElement(Text.span, {
      color: 'primary.base',
      textStyle: 'heading6',
      style: {
        textDecoration: 'none !important'
      }
    }, "Please try again.")),
    buttonClick: tryAgainHandler
  }));
};
export default TryAgain;